import React from "react";

export const AuthLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="relative min-h-screen bg-auth-background overflow-hidden">
      <div className="absolute top-0 right-0 w-1/2 h-full"></div>

      <div className="relative w-full max-w-4xl mx-auto"></div>

      <div className="relative flex flex-col w-full min-h-screen justify-center">
        {children}
      </div>
    </div>
  );
};
